import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import cz_CZ from "./cz_CZ";
import de_DE from "./de_DE";
import dk_DK from "./dk_DK";
import en_US from "./en_US";
import fr_FR from "./fr_FR";
import hu_HU from "./hu_HU";
import it_IT from "./it_IT";
import nl_NL from "./nl_NL";
import pl_PL from "./pl_PL";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      "de-DE": de_DE,
      "en-US": en_US,
      "fr-FR": fr_FR,
      "nl-NL": nl_NL,
      "it-IT": it_IT,
      "dk-DK": dk_DK,
      "cs-CZ": cz_CZ,
      "hu-HU": hu_HU,
      "pl-PL": pl_PL,
    },
  });

export default i18n;
